import updatesReducer from './updates';

export * from './updates';
export * from './updates.types';

export default updatesReducer;
